var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"breadcrumbs":_vm.breadcrumbs}},[_c('div',{attrs:{"id":"ya-site-results","data-bem":"{\"tld\": \"ru\",\"language\": \"ru\",\"encoding\": \"\"}"}})])}
var staticRenderFns = []

export { render, staticRenderFns }